/**
 * @format
 */
const MDFDashboardIndex = () => import('@/views/mdf/mdf-dashboard-index-view');
const MDFManagementIndex = () => import('@/views/mdf/mdf-management-index-view');
const AgencyMDFSettings = () => import('@/views/mdf/agency-mdf-settings-view');
const AgencyMDFPartners = () => import('@/views/mdf/agency-mdf-partners-view');
const AgencyMDFPreapprovedFunds = () => import('@/views/mdf/agency-mdf-preapproved-funds-view');
const AgencyMDFAllocateGiveFundsForm = () =>
    import('@/views/mdf/agency-mdf-allocate-give-funds-form-view');
const AvailableVendor = () => import('@/views/mdf/client-mdf-available-vendor-view');
const AgencyMDFReviewPOP = () => import('@/views/mdf/agency-mdf-review-pop-view');
const RequestMDF = () => import('@/views/mdf/client-mdf-request-form-view');

export default [
    {
        path: '/MDF/Dashboard',
        name: 'MDFDashboard',
        component: MDFDashboardIndex,
        meta: {
            isUiShown: true,
            pageClass: 'mdf-dashboard-page',
            pageTitle: 'MDF Dashboard',
            subtype: 'mdf',
        },
    },
    {
        path: '/MDF/Settings',
        name: 'MDFSettings',
        component: AgencyMDFSettings,
        meta: {
            type: 'Agency',
            isUiShown: true,
            pageClass: 'mdf-settings-index-page',
            pageTitle: 'MDF Settings',
            subtype: 'mdf',
        },
    },
    {
        path: '/MDF/Management',
        name: 'MDFManagement',
        component: MDFManagementIndex,
        meta: {
            isUiShown: true,
            pageClass: 'mdf-management-page',
            pageTitle: 'MDF Management',
            subtype: 'mdf',
        },
    },
    {
        path: '/MDF/Partners',
        name: 'MDFPartner',
        component: AgencyMDFPartners,
        meta: {
            type: 'Agency',
            isUiShown: true,
            subtype: 'mdf',
            pageClass: 'mdf-partners-page',
            pageTitle: 'MDF Partners',
        },
    },
    {
        path: '/MDF/Request',
        name: 'AvailableVendor',
        component: AvailableVendor,
        meta: {
            type: 'Client',
            isUiShown: true,
            subtype: 'mdf',
            pageClass: 'mdf-available-vendor',
            pageTitle: 'Available Vendors',
        },
    },
    {
        path: '/MDF/Request/Apply/:companyId',
        name: 'RequestMDF',
        component: RequestMDF,
        meta: {
            type: 'Client',
            isUiShown: true,
            subtype: 'mdf',
            pageClass: 'mdf-request-mdf',
            pageTitle: 'MDF Request',
        },
    },
    {
        path: '/MDF/Partners/:partnerId/Funds/Allocate',
        name: 'MDFPartnerAllocateFunds',
        component: AgencyMDFAllocateGiveFundsForm,
        meta: {
            type: 'Agency',
            isUiShown: true,
            subtype: 'mdf',
            pageClass: 'agency-mdf-allocate-give-funds-form-page',
            pageTitle: 'MDF Allocate Funds',
        },
    },
    {
        path: '/MDF/Partners/:partnerId/Funds/Give',
        name: 'MDFPartnerGiveFunds',
        component: AgencyMDFAllocateGiveFundsForm,
        meta: {
            type: 'Agency',
            isUiShown: true,
            subtype: 'mdf',
            pageClass: 'agency-mdf-allocate-give-funds-form-page',
            pageTitle: 'MDF Give Funds',
        },
    },
    {
        path: '/MDF/Requests/:requestId/Funds/Allocate',
        name: 'MDFRequestAllocateFunds',
        component: AgencyMDFAllocateGiveFundsForm,
        meta: {
            type: 'Agency',
            isUiShown: true,
            subtype: 'mdf',
            pageClass: 'agency-mdf-allocate-give-funds-form-page',
            pageTitle: 'MDF Allocate Funds',
        },
    },
    {
        path: '/MDF/Requests/:requestId/Funds/Deny',
        name: 'MDFRequestDenyFunds',
        component: AgencyMDFAllocateGiveFundsForm,
        meta: {
            type: 'Agency',
            isUiShown: true,
            subtype: 'mdf',
            pageClass: 'agency-mdf-allocate-give-funds-form-page',
            pageTitle: 'MDF Deny Funds',
        },
    },
    {
        path: '/MDF/Requests/:requestId/POP/Review',
        name: 'MDFPOPReview',
        component: AgencyMDFReviewPOP,
        meta: {
            type: 'Agency',
            isUiShown: true,
            subtype: 'mdf',
            pageClass: 'agency-mdf-review-pop-page',
            pageTitle: 'MDF Review POP',
        },
    },
    {
        path: '/MDF/Partners/:partnerId/Funds/Preapprove',
        name: 'MDFPartnerPreapproveFunds',
        component: AgencyMDFAllocateGiveFundsForm,
        meta: {
            type: 'Agency',
            isUiShown: true,
            subtype: 'mdf',
            pageClass: 'agency-mdf-allocate-preapprove-funds-form-view',
            pageTitle: 'MDF Preapprove Funds',
        },
    },
    {
        path: '/MDF/Funds/Preapprove',
        name: 'MDFPreapproveFunds',
        component: AgencyMDFAllocateGiveFundsForm,
        meta: {
            type: 'Agency',
            isUiShown: true,
            subtype: 'mdf',
            pageClass: 'agency-mdf-allocate-preapprove-funds-form-view',
            pageTitle: 'MDF Preapprove Funds',
        },
    },
    {
        path: '/MDF/PreapprovedFunds',
        name: 'MDFPreapprovedFunds',
        component: AgencyMDFPreapprovedFunds,
        meta: {
            type: 'Agency',
            isUiShown: true,
            subtype: 'mdf',
            pageClass: 'mdf-preapproved-funds-page',
            pageTitle: 'MDF Preallocated Funds',
        },
    },
    // AGENCY
    {
        path: '/Agencies/:agencyId/MDF/Dashboard',
        name: 'MDFDashboardAgency',
        component: MDFDashboardIndex,
        meta: {
            type: 'Agency',
            isUiShown: true,
            pageClass: 'mdf-dashboard-page',
            pageTitle: 'MDF Dashboard',
            subtype: 'mdf',
        },
    },
    {
        path: '/Agencies/:agencyId/MDF/Settings',
        name: 'MDFSettingsAgency',
        component: AgencyMDFSettings,
        meta: {
            type: 'Agency',
            isUiShown: true,
            pageClass: 'mdf-settings-index-page',
            pageTitle: 'MDF Settings',
            subtype: 'mdf',
        },
    },
    {
        path: '/Agencies/:agencyId/MDF/Management',
        name: 'MDFManagementAgency',
        component: MDFManagementIndex,
        meta: {
            type: 'Agency',
            isUiShown: true,
            pageClass: 'mdf-management-page',
            pageTitle: 'MDF Management',
            subtype: 'mdf',
        },
    },
    {
        path: '/Agencies/:agencyId/MDF/Partners',
        name: 'AgencyMDFPartner',
        component: AgencyMDFPartners,
        meta: {
            type: 'Agency',
            isUiShown: true,
            subtype: 'mdf',
            pageClass: 'mdf-partners-page',
            pageTitle: 'MDF Partners',
        },
    },
    {
        path: '/Agencies/:agencyId/MDF/PreapprovedFunds',
        name: 'AgencyMDFPreapprovedFunds',
        component: AgencyMDFPreapprovedFunds,
        meta: {
            type: 'Agency',
            isUiShown: true,
            subtype: 'mdf',
            pageClass: 'mdf-preapproved-funds-page',
            pageTitle: 'MDF Preallocated Funds',
        },
    },
    {
        path: '/Agencies/:agencyId/MDF/Partners/:partnerId/Funds/Allocate',
        name: 'AgencyMDFPartnerAllocateFunds',
        component: AgencyMDFAllocateGiveFundsForm,
        meta: {
            type: 'Agency',
            isUiShown: true,
            subtype: 'mdf',
            pageClass: 'agency-mdf-allocate-give-funds-form-page',
            pageTitle: 'MDF Allocate Funds',
        },
    },
    {
        path: '/Agencies/:agencyId/MDF/Partners/:partnerId/Funds/Give',
        name: 'AgencyMDFPartnerGiveFunds',
        component: AgencyMDFAllocateGiveFundsForm,
        meta: {
            type: 'Agency',
            isUiShown: true,
            subtype: 'mdf',
            pageClass: 'agency-mdf-allocate-give-funds-form-page',
            pageTitle: 'MDF Give Funds',
        },
    },
    {
        path: '/Agencies/:agencyId/MDF/Requests/:requestId/Funds/Allocate',
        name: 'AgencyMDFRequestAllocateFunds',
        component: AgencyMDFAllocateGiveFundsForm,
        meta: {
            type: 'Agency',
            isUiShown: true,
            subtype: 'mdf',
            pageClass: 'agency-mdf-allocate-give-funds-form-page',
            pageTitle: 'MDF Allocate Funds',
        },
    },
    {
        path: '/Agencies/:agencyId/MDF/Requests/:requestId/Funds/Deny',
        name: 'AgencyMDFRequestDenyFunds',
        component: AgencyMDFAllocateGiveFundsForm,
        meta: {
            type: 'Agency',
            isUiShown: true,
            subtype: 'mdf',
            pageClass: 'agency-mdf-allocate-give-funds-form-page',
            pageTitle: 'MDF Deny Funds',
        },
    },
    {
        path: '/Agencies/:agencyId/MDF/Requests/:requestId/POP/Review',
        name: 'AgencyMDFPOPReview',
        component: AgencyMDFReviewPOP,
        meta: {
            type: 'Agency',
            isUiShown: true,
            subtype: 'mdf',
            pageClass: 'agency-mdf-review-pop-page',
            pageTitle: 'Vendor MDF Review POP',
        },
    },
    {
        path: '/Agencies/:agencyId/MDF/Partners/:partnerId/Funds/Preapprove',
        name: 'AgencyMDFPartnerPreapproveFunds',
        component: AgencyMDFAllocateGiveFundsForm,
        meta: {
            type: 'Agency',
            isUiShown: true,
            subtype: 'mdf',
            pageClass: 'agency-mdf-allocate-preapprove-funds-form-view',
            pageTitle: 'MDF Preapprove Funds',
        },
    },
    {
        path: '/Agencies/:agencyId/MDF/Funds/Preapprove',
        name: 'AgencyMDFPreapproveFunds',
        component: AgencyMDFAllocateGiveFundsForm,
        meta: {
            type: 'Agency',
            isUiShown: true,
            subtype: 'mdf',
            pageClass: 'agency-mdf-allocate-preapprove-funds-form-view',
            pageTitle: 'MDF Preapprove Funds',
        },
    },
    // PARTNER
    {
        path: '/Clients/:clientId/MDF/Dashboard',
        name: 'ClientMDFDashboard',
        component: MDFDashboardIndex,
        meta: {
            type: 'Client',
            isUiShown: true,
            pageClass: 'mdf-dashboard-page',
            pageTitle: 'MDF Dashboard',
            subtype: 'client-mdf',
        },
    },
    {
        path: '/Clients/:clientId/MDF/Management',
        name: 'ClientMDFManagement',
        component: MDFManagementIndex,
        meta: {
            type: 'Client',
            isUiShown: true,
            pageClass: 'mdf-management-page',
            pageTitle: 'MDF Management',
            subtype: 'client-mdf',
        },
    },
    {
        path: '/Clients/:clientId/MDF/Request',
        name: 'ClientAvailableVendor',
        component: AvailableVendor,
        meta: {
            type: 'Client',
            isUiShown: true,
            subtype: 'client-mdf',
            pageClass: 'mdf-available-vendor',
            pageTitle: 'Availabe Vendors',
        },
    },
    {
        path: '/Clients/:clientId/MDF/Request/Apply/:companyId',
        name: 'ClientRequestMDF',
        component: RequestMDF,
        meta: {
            type: 'Client',
            isUiShown: true,
            subtype: 'client-mdf',
            pageClass: 'mdf-request-mdf',
            pageTitle: 'MDF Request',
        },
    },
];
